import axios from "axios";
import {
  RECAPTCHA_CONSTANT_FAIL,
  RECAPTCHA_CONSTANT_REQUEST,
  RECAPTCHA_CONSTANT_SUCCESS,
} from "../constants/recaptchaConstants";
export const callRecaptcha = () => async (dispatch) => {
  try {
    dispatch({
      type: RECAPTCHA_CONSTANT_REQUEST,
    });

    const { data } = await axios.get("/api/config/reCAPTCHA");
    dispatch({
      type: RECAPTCHA_CONSTANT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: RECAPTCHA_CONSTANT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
